// extracted by mini-css-extract-plugin
module.exports = {"button":"_9e1425b4d3--button--deFJi"};